/* eslint-disable react/no-danger */
import * as React from 'react';

// @ts-expect-error TS7016 Untyped import http://go.dkandu.me/strict-ts-migration#TS7016
import showdown from 'showdown';

import type { BrowseFaq } from 'bundles/browse/components/Faq/BrowseFAQs';
import { clearEmptyFields } from 'bundles/seo/utils/utils';

type Props = {
  faqs?: Array<BrowseFaq | null>;
  isEntityPage?: boolean;
  rootClassName?: string;
};

class BrowseEntityFAQSchemaMarkup extends React.Component<Props, {}> {
  // Rationale: Because browse and entity FAQs are powered by Contentful, which sends the strings to us
  // as Markdown, we need to convert them to HTML for use in our schema markup as directed by the SEO team.
  getHtmlMarkupFromConverter = (markdownSrc: string) => {
    const htmlFromConverter = this.markdownToHtmlConverter.makeHtml(markdownSrc);
    return htmlFromConverter;
  };

  markdownToHtmlConverter = new showdown.Converter();

  generateBrowseEntityFAQMarkup = () => {
    const { faqs } = this.props;
    if (!faqs || faqs.length === 0) {
      return null;
    }
    return (
      faqs
        // Filter returns non-null type, letting Typescript know this
        .filter((faq): faq is BrowseFaq => !!faq)
        .map(({ question, answer }) => ({
          '@type': 'Question',
          name: this.getHtmlMarkupFromConverter(question),
          acceptedAnswer: {
            '@type': 'Answer',
            text: this.getHtmlMarkupFromConverter(answer),
          },
        }))
    );
  };

  render() {
    const { isEntityPage, faqs, rootClassName } = this.props;
    if (!faqs || faqs.length === 0) {
      return null;
    }

    const markupJson = {
      '@context': 'http://schema.org',
      '@type': 'FAQPage',
      mainEntity: this.generateBrowseEntityFAQMarkup(),
    };

    const createMarkup = () => ({
      __html: `
        <script type="application/ld+json">
          ${JSON.stringify(clearEmptyFields(markupJson))}
        </script>
      `,
    });

    const className = rootClassName || (isEntityPage ? 'rc-EntityPageFAQSchemaMarkup' : 'rc-BrowseFAQSchemaMarkup');

    return (
      <div className={className}>
        <div dangerouslySetInnerHTML={createMarkup()} />
      </div>
    );
  }
}

export default BrowseEntityFAQSchemaMarkup;
